import { AppStorage } from "@bbwt/utils/app-storage";
import { PrescriptionLine } from "@project/models/prescriptions/prescription-line";
import { PrescriptionOfflineStorage } from "@project/prescription/classes/prescription-offline.storage";

export class PrescriptionLineOfflineStorage {
    private static readonly cacheKey = "api/prescription/lines";

    static save(line: PrescriptionLine): PrescriptionLine {
        return AppStorage.setOfflineEntity<PrescriptionLine>(this.cacheKey, line);
    }

    static get(id: string): PrescriptionLine {
        return AppStorage.getOfflineEntity<PrescriptionLine>(id, this.cacheKey);
    }

    static getAll(): PrescriptionLine[] {
        return AppStorage.getOfflineEntities<PrescriptionLine>(this.cacheKey);
    }

    static update(prescriptionLine: PrescriptionLine) {
        return AppStorage.replaceOfflineEntity(prescriptionLine, this.cacheKey);
    }

    static remove(id: string): PrescriptionLine {
        return AppStorage.extractOfflineEntity<PrescriptionLine>(id, this.cacheKey);
    }

    static removeLines(prescriptionId: string): void {
        const ids = this.getAll().filter(pl => pl.prescriptionId == prescriptionId).map(pl => pl.id);
        ids.forEach(id => this.remove(id));
    }

    static updatePatientId(oldPatientId: string, patientId: string): void {
        const patientPrescriptionLines = this.getAll()
            .filter(pl => pl.patientId == oldPatientId)
            .map(pl => ({ ...pl, patientId }));

        patientPrescriptionLines.forEach(pl => this.update(pl));

        PrescriptionOfflineStorage.updatePatientId(oldPatientId, patientId);
    }
}
